import { createSelectorPage } from 'pages/common/selector'
import { urls } from 'urls'

const metadata = {
  title: 'menu.lookups',
  baseUrl: urls.lookups.base
}
const LookupSelectorPage = createSelectorPage({ metadata })

export {
  LookupSelectorPage
}